// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"style_backdrop__2DuPE"};